import { constants } from 'helpers'
import { useFt } from 'hooks'


const useCollaboration = (): CollaborationsModule.Collaboration => {
  const isSaksCollaborationEnabled = useFt(constants.features.collaborationSaks)

  if (isSaksCollaborationEnabled) {
    return 'saks'
  }

  return null
}

export default useCollaboration
